'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BasketConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BasketConstants = exports.BasketConstants = (0, _keymirror2.default)({
    ADD_BASKET: null,
    REMOVE_BASKET: null,
    CHANGE_COUNT_PRODUCT_IN_BASKET: null,
    CLEAR_BASKET: null,
    CHANGE_BASKET: null,
    ORDER_LOAD: null,
    ORDER_LOAD_SUCCESS: null,
    ORDER_LOAD_FAIL: null,
    COPY_TO_BASKET: null,

    SHARE_BASKET_LOAD: null,
    SHARE_BASKET_SUCCESS: null,
    SHARE_BASKET_FAIL: null,

    GET_SHARE_BASKET_FAIL: null,
    GET_SHARE_BASKET_SUCCESS: null,
    GET_SHARE_BASKET_LOAD: null,

    BASKET_RESET_SHARE_CODE: null,

    BASKET_CHANGE_SHARE: null,

    GET_ACTUAL_PRICES_FAIL: null,
    GET_ACTUAL_PRICES_SUCCESS: null,
    GET_ACTUAL_PRICES_LOAD: null,
    ADD_COUPON_IN_BASKET: null,

    POSTPONE_BASKET_LOAD: null,
    POSTPONE_BASKET_SUCCESS: null,
    POSTPONE_BASKET_FAIL: null,

    GET_POSTPONE_BASKET_LOAD: null,
    GET_POSTPONE_BASKET_SUCCESS: null,
    GET_POSTPONE_BASKET_FAIL: null,

    DELETE_POSTPONE_LOAD: null,
    DELETE_POSTPONE_SUCCESS: null,
    DELETE_POSTPONE_FAIL: null,

    MERGE_POSTPONE_LOAD: null,
    MERGE_POSTPONE_SUCCESS: null,
    MERGE_POSTPONE_FAIL: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/basket.js
// module id = 1866
// module chunks = 0